﻿import $ from "../../../scripts/vendor/jquery";
import { EventEmitter } from "../../../utils";
import { events } from "../../../scripts/constants";

var jQuery = $;

var settings = {
  errorContainer: "#errorContainer",
  alertContainer: ".alert",
  buttonContainer: ".confirm",
  closeButton: ".close",
  errorDuration: 6000,
};

$(settings.errorContainer)
  .find(settings.closeButton)
  .on("click", function () {
    $(settings.errorContainer).removeClass("show");
  });

function reportError(errorCode, errorMsg) {
  // we have a div in the basketbar html to look after our error messages.
  let errorContainer = $(settings.errorContainer),
    errorDisplay = errorMsg,
    friendlyMsg = "not set up yet";

  //TO DO: use error code to get a friendly error message if available

  //populate the on page container with the message and display it
  errorContainer.find(settings.alertContainer).html(errorDisplay);
  errorContainer.addClass("show");

  //call logError so that this error makes it's way into aplication insights - see Ed.
  logError(errorCode, errorMsg, friendlyMsg);

  //hide the error msg after the set duration
  setTimeout(function () {
    errorContainer.removeClass("show");
  }, settings.errorDuration);
}

EventEmitter.on(events.REPORT_ERROR, ({ errorCode, errorMsg }) => {
  reportError(errorCode, errorMsg);
});

/**
 * @param {string} message
 */
function errorConfirm(message) {
  let errorContainer = $(settings.errorContainer),
    buttonContainer = $(settings.buttonContainer);

  errorContainer.find(settings.alertContainer).html(message);
  buttonContainer.addClass("show");
  errorContainer.addClass("show");

  return new Promise(function (resolve, reject) {
    // do a thing, possibly async, then…

    errorContainer.find("button").on("click", function () {
      if ($(this).data("value")) {
        resolve(true);
        buttonContainer.removeClass("show");
        errorContainer.removeClass("show");
      } else {
        resolve(false);
        buttonContainer.removeClass("show");
        errorContainer.removeClass("show");
      }
    });
  });
}

function logError(errorCode, errorMsg, friendlyMsg) {
  //log to Application Insights
  const appInsights = window["appInsights"];
  if (appInsights !== undefined) {
    var properties = { code: errorCode, full_error: errorMsg, user_error: friendlyMsg };
    appInsights.trackEvent("Basket Integration Error", properties);
  }
}

export { logError, reportError, errorConfirm };
